var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786.995,
    height: 848.697,
    viewBox: "0 0 208.226 224.551",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.648 120.922h282.968v305.153H310.648Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.73586 0 0 -.73586 -228.595 313.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.733 366.017c-55.257-15.645-82.35-79.561-54.724-129.985C403.23 185.038 473 169.346 516.82 208.877a81.68 81.68 0 0 1 10.405 11.158l-.482-.106-1.699 4.128a84.981 84.981 0 0 0-5.168-5.77c-47.178-48.833-129.412-32.157-147.856 34.94-10.755 39.266 8.17 82.675 44.608 100.941 32.678 17.181 72.633 10.906 99.188-11.808l1.814 1.378c-22.23 21.693-54.749 31.62-86.898 22.279",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.79 233.949c-9.068-25.11-25.094-47.788-46.556-64.563-89.876-70.291-219.912-16.587-229.204 98.34-6.571 88.428 68.788 161.222 156.869 151.997 33.99-3.314 65.67-19.144 88.874-43.218l1.548 1.175c-35.792 39.724-92.208 58.753-146.732 42.701-88.01-24.932-131.318-126.563-87.929-207.162 31.18-59.955 103.691-92.255 168.951-73.6 48.206 13.086 83.064 50.355 97.004 94.948z",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.584 371.904c-43.405-34.553-56.259-96.927-29.705-145.642 34.895-65.94 124.638-85.375 181.031-34.697 11.328 9.988 20.243 22.255 26.58 35.751l-4.203-.92c-7.439-13.332-17.52-25.27-29.766-34.819-72.025-56.229-175.971-13.741-183.2 78.548-5.035 70.648 55.059 128.595 125.412 121.38 26.234-2.498 50.817-14.259 69.252-32.309l1.69 1.285c-39.43 42.27-106.855 51.556-157.091 11.424",
    style: {
      fill: "#4993c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.291 278.766c0-17.637-14.297-31.936-31.935-31.936-17.637 0-31.936 14.299-31.936 31.936 0 17.638 14.299 31.935 31.936 31.935 17.638 0 31.935-14.297 31.935-31.935",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.283 350.63-9.072 15.712 9.072 15.714h18.145l9.073-15.714-9.073-15.713z",
    style: {
      fill: "#e95329",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.234 120.922-16.029 27.766 16.03 27.763h32.06l16.032-27.763-16.031-27.766z",
    style: {
      fill: "#a72f62",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.448 288 15.714 9.073 15.713-9.072v-18.145l-15.713-9.072-15.714 9.072z",
    style: {
      fill: "#1e6eac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.023 239.544 17.526-4.696 4.696-17.526-12.83-12.83-17.525 4.695-4.697 17.526z",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.469 405.499 36.068-9.664 9.663-36.07-26.403-26.403-36.068 9.666-9.665 36.066z",
    style: {
      fill: "#fbbc00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.22 392.822.725 18.13 16.064 8.437 15.338-9.693-.726-18.129-16.064-8.438z",
    style: {
      fill: "#99c22e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.384 186.3 11.779 34.458 35.732 7.029 23.952-27.43-11.78-34.461-35.73-7.026z",
    style: {
      fill: "#009149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesMenu);
export default __webpack_public_path__ + "static/media/ServicesMenu.9cccdb9dd2a813f9e641d3a55f25eb64.svg";
export { ForwardRef as ReactComponent };